<template>
  <div>
    <table
      v-for="(props, header) in contactList"
      :key="header"
      class="table table-striped table-sm mb-4"
    >
      <tbody>
        <th class="header">
          {{ $t(`processes.sidebar.${header}`) }}
        </th>
        <tr
          v-for="(val, key) in props"
          :key="key"
        >
          <th scope="row">
            {{ $t(`recordList.${key}`) }}
          </th>
          <td>
            <div
              v-if="key === 'ProjectAssignee'"
              class="select"
            >
              <b-spinner
                v-if="isSaving"
                variant="secondary"
                class="field-save-spinner"
              />
              <SelectField
                :options="fieldOptions"
                :value="val"
                :disabled="disabled"
                @input="event => handleUpdateAssignee(key, event)"
              />
            </div>

            <div v-else>
              {{ val }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import recordList from '@/helpers/recordList'
import SelectField from '@/components/form/elements/SelectField.vue'
// eslint-disable-next-line no-unused-vars
import { updateProcessField } from '@/services/processes'
import { mapGetters } from 'vuex'

export default {
  name: 'RealisationSidebarContactTab',
  components: {
    SelectField
  },
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isSaving: false
    }
  },
  computed: {
    ...mapGetters('processes', ['getSelectedProcess']),
    ...mapGetters('tenant', ['getSelectableWorkflowUsers']),
    uuid() {
      return this.record.uuid
    },
    hasCaseRef() {
      return !!this.record.case_ref
    },
    fieldOptions () {
      return this.getSelectableWorkflowUsers
    },
    disabled () {
      return this.record.status.locked || this.isSaving
    },
    externalContacts () {
      const stakeholders = this.record.Stakeholders
      const external = {}
      Object.keys(stakeholders).forEach(stakeholder => {
        const { Firstname, Lastname } = stakeholders[stakeholder]
        if (Firstname || Lastname) {
          external[stakeholder] = Firstname ? Firstname + ' ' : Lastname ? Lastname : ''
        }
      })
      return external
    },
    contactList () {
      const { Object } = this.getSelectedProcess.CurrentLocation
      return {
        internal: {
          ProjectAssignee: Object.ProjectAssignee,
          updatedBy: recordList.setWorkflowUserValue({ fieldValue: this.getSelectedProcess.updatedBy.userId }),
          ProjectCoordinator: recordList.setWorkflowUserValue({ fieldValue: Object.ProjectCoordinator })
        },
        external: { ...this.externalContacts }
      }
    }
  },
  methods: {
    async handleUpdateAssignee (key, value) {
      const currentAssignee = this.getSelectedProcess.CurrentLocation.Object.ProjectAssignee
      if (value === currentAssignee) return;

      this.isSaving = true
      const token = await this.$auth.getTokenSilently()
      const user = this.$auth.user
      const setData = {
        [`process.Object.${key}`]: value
      }
      const field = { key, value, user, setData }

      await updateProcessField({ token, process: { uuid: this.record.uuid }, field  })
        .catch(() => {
          return this.$store.dispatch('tenant/setToast', {
            message: this.$i18n.t('generalMessages.somethingIsWrong'),
            error: true,
            variant: 'danger',
            delay: 100
          });
        })
        .finally(() => this.isSaving = false )

      this.getSelectedProcess.CurrentLocation.Object.ProjectAssignee = value
      this.$store.dispatch('processes/setSelectedProcess', { process: this.getSelectedProcess })

      this.$store.dispatch('tenant/setToast', {
        message: this.$i18n.t('Process.fieldSaved', { field: this.$i18n.t(`recordList.${key}`) }),
        delay: 100
      });
    }
  }
}
</script>
<style lang="scss" scoped>
  .custom-select {
    min-height: 35px;
  }
  .select {
    position: relative;
    .field-save-spinner {
      width: 1rem;
      height: 1rem;
      border-width: 3px;
      position: absolute;
      top: 10px;
      right: 30px;
    }
  }
  .table {
    .header {
      font-weight: normal;
      font-size: 1.3em;
    }
    th {
      width: 50%;
    }
  }
</style>
